import React, { useEffect, useRef, useState } from 'react';
import SupplierMatchingService from "../../../services/SupplierMatchingService";
import Cs from '../../../services/CommonService';
import { Link, useHistory } from "react-router-dom";
import { useClientSearch } from '../../../hooks/useSearch';

const colorIdx = [
  { bg: 'bg-blue-dark'  },
  { bg: 'bg-username'   },
  { bg: 'bg-instagram'  },
  { bg: 'bg-green'      },
  { bg: 'bg-safforn'    },
  { bg: 'bg-voilet'     },
  { bg: 'bg-lred'       },
  { bg: 'bg-lblue'      },
];

const SectionCard = ({ children, extraClass = '' }) => (
  <div className={`bg-white brd-10 shadow-small p-20 m-b-20 ${extraClass}`}>{children}</div>
);

const CardHeader = ({ title, action, onAction }) => (
  <div className="flex justspacebetween aligncenter m-b-15">
    <span className="fw700 font-15 color-black">{title}</span>
    {action && <span className="font-12 highlight pointer fw500" onClick={onAction}>{action}</span>}
  </div>
);

const OrgFaculties = ({list=[]}) => list.map((m, i) => {
  const {data, data_source:ds} = m;
  return(
    <div key={i} className="text-center p-15 br-grey brd-10">
      <div className={`circle-avatar-md flex aligncenter justifycenter fw700 font-18 text-white mx-auto m-b-10 ${colorIdx[i]?.bg}`}>{Cs.getInitials(data.name)}</div>
      <div className="font-13 fw500 dark-navy">{data.name}</div>
      <div className="font-11 lgrey m-t-2">{ds.affiliated_dept?.[0]?.label}</div>
      <span className="badge-3 bg-red1-dark white m-t-6">{ds?.designation?.label}</span>
      <Link to={`/faculty/profile/${m.id}`} className="bg-blue-white highlight brd-5 fw500 font-12 w-100p p-5 m-t-10 no-border pointer">
        View
      </Link>
    </div>
  )
})

const OrgAlumnis = ({list=[]}) => list.map((m, i) => {
  const {data, data_source:ds} = m;
  return(
    <div key={i} className="text-center p-15 br-grey brd-10">
      <div className={`circle-avatar-md flex aligncenter justifycenter fw700 font-18 text-white mx-auto m-b-10 ${colorIdx[i]?.bg}`}>{Cs.getInitials(data.name)}</div>
      <div className="font-13 fw500 dark-navy">{data.name}</div>
      <div className="font-11 lgrey m-t-2">{ds.startup_industry?.label}</div>
      <span className="badge-3 bg-red1-dark white m-t-6">{ds?.specialization?.label}</span>
      <Link to={`/alumni/profile/${m.id}`} className="bg-blue-white highlight brd-5 fw500 font-12 w-100p p-5 m-t-10 no-border pointer">
        View
      </Link>
    </div>
  )
})

const Suppliers = ({list=[]}) => list.map((m, i) => {
  const {data, data_source:ds} = m;
  return(
    <div key={i} className="text-center p-15 br-grey brd-10">
      <div className={`circle-avatar-md flex aligncenter justifycenter fw700 font-18 text-white mx-auto m-b-10 ${colorIdx[i]?.bg}`}>{Cs.getInitials(data.name)}</div>
      <div className="font-13 fw500 dark-navy">{data.name}</div>
      <div className="font-11 lgrey m-t-2">{ds?.startup_industry?.label ?? 'N/A'}</div>
      <span className="badge-3 bg-red1-dark white m-t-6">{ds?.specialization?.label ?? 'N/A'}</span>
      <button className="bg-blue-white highlight brd-5 fw500 font-12 w-100p p-5 m-t-10 no-border pointer">
        View
      </button>
    </div>
  )
})

const MatchingSuppliers = ({orgRegistration, projectRequest}) => {
  let { current: scope } = useRef({ requestParams: {}, sourceFaculties: [], sourceAlumnis: [], sourceSuppliers: [] });
  const [orgAlumnis, setOrgAlumnis] = useState([]);
  const [orgFaculties, setOrgFaculties] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAll();
  }, []);

  const getAll = async () => {
    setLoading(true);
    const { status, data } = await SupplierMatchingService.getAll({
      'journey_id': projectRequest.id,
      'org_obd_id': orgRegistration.id
    });
    if (status === 200) {
      scope.sourceFaculties = data.org_faculties ?? [];
      scope.sourceAlumnis = data.org_alumnis ?? [];
      scope.sourceSuppliers = data.suppliers ?? [];
      setOrgFaculties(scope.sourceFaculties);
      setOrgAlumnis(scope.sourceAlumnis);
      setSuppliers(scope.sourceSuppliers);
    }
    setLoading(false);
  };

  const { onSearch: onSearchFaculties } = useClientSearch(scope.sourceFaculties, setOrgFaculties);
  const { onSearch: onSearchAlumnis } = useClientSearch(scope.sourceAlumnis, setOrgAlumnis);
  const { onSearch: onSearchSuppliers } = useClientSearch(scope.sourceSuppliers, setSuppliers);

  const onSearchChange = (e) => {
    onSearchFaculties(e);
    onSearchAlumnis(e);
    onSearchSuppliers(e);
  };

  return (
    <SectionCard>
      <div className="flex justspacebetween aligncenter m-b-15">
        <span className="fw700 font-15 color-black">Members</span>
        <div className="input-group w-200">
          <input type="text" onChange={onSearchChange} placeholder="Search members..." className="form-control input-sm" />
        </div>
      </div>
      <div className="grid-4col gap-15">
        <OrgFaculties list={orgFaculties}/>
        <OrgAlumnis list={orgAlumnis}/>
        <Suppliers list={suppliers}/>
        {!loading && orgFaculties.length === 0
          && orgAlumnis.length === 0
          && suppliers.length === 0
          && <div className="text-muted">No match found.</div>
        }
      </div>
    </SectionCard>
  );
};

export default MatchingSuppliers;